import React, { useState, useEffect } from "react";

const Principle = () => {
  const [principleData, setPrincipleData] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/${school}/items/founder_message?fields=*.*`
        );
        const data = await response.json();

        // Assuming data is structured like { data: [...] }
        if (data && data.data && data.data.length > 0) {
          setPrincipleData(data.data[0]);

          // Assuming you only want the first item
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [baseUrl,school]); // Empty dependency array to run useEffect only once on component mount

  return (
    <>
      {principleData && (
        <div className="principal">
          <div className="principal-row">
            <div className="principal-col">
              {/* Use the image from the API response */}

              <div className="principalimg1">
                {principleData.founder_image && (
                  <img
                  alt="principal"
                    src={principleData.founder_image.data.full_url?.replace(
                      "http://",
                      "https://"
                    )}
                  />
                )}
              </div>
              <div className="principalimg2">
                <img styles={{}} src="./logo1-rbg.png" alt="#" />
              </div>
              <div className="principalimg3">
                {principleData.founder_image && (
                  <img src="./principal2.png" alt="principal img" />
                )}
              </div>

              {/* Assuming you have a name property in your API response */}
              {/* <h5>{principleData.founder_name}</h5> */}
            </div>
            <div className="principal-msg">
              <h2 className="text-uppercase">founder's Message</h2>

              <h6
                dangerouslySetInnerHTML={{
                  __html: principleData?.founder_message,
                }}
              />
            </div>
          </div>
          <div className="principal-row">
            <div  >
              {/* Use the image from the API response */}

              <div className="principalimg4" id="right-align">

                <img src="./principal3.png" alt="principal img" />

              </div>

              {/* Assuming you have a name property in your API response */}
              {/* <h5>{principleData.founder_name}</h5> */}
            </div>
            <div className="principal-msg">
              <h6>
                <b> Dear Students, Parents, and Staff,  </b> <br />
                It is with great pride and humility that I address you today as the wife of the late Mr. Narayan Singh Kushwaha, 
                the founder of this esteemed school. My husband had a vision of creating an institution that would provide the highest quality education to students from all walks of life, and it is a testament to his legacy that his dream continues to thrive today. 
                <br />  Although my husband is no longer with us, his spirit lives on in the work we do every day at this school. I am humbled by the dedication and commitment of our faculty, staff, and students in upholding the values my husband held dear—excellence, integrity, and a deep commitment to serving our community. 
                <br /> 
                I am grateful for the support and encouragement our school has received from families and the community over the years. It is through your unwavering support that we continue to provide a world-class education to our students.
                 <br /> As we look to the future, I am confident that this school will remain a beacon of hope, opportunity, and excellence for generations to come. My husband's vision was to create an institution that would make a difference in the lives of young people, and I am proud to say that his dream has become a reality.
                  <br />  Thank you for your continued support of our school and for helping to keep my husband's legacy alive.
                   <br /> Sincerely, <br /> <b>Smt. Sheela Singh Kushwaha</b>
                <br /> Wife of the Late Mr. Narayan Singh Kushwaha
              </h6>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Principle;
